<template>
  <b-modal
    v-model="isModalVisible"
    title="Все теги"
    size="lg"
    ok-only
    ok-title="Закрыть"
    centered
    scrollable
  >
    <b-form-group class="mb-2">
      <b-form-input
        v-model="searchText"
        placeholder="Поиск по названию"
        type="text"
      />
    </b-form-group>

    <div
      v-if="!filteredTags.length"
      class="text-center text-muted py-2"
    >
      Теги не найдены
    </div>

    <div
      v-else
      class="all-tags-list"
    >
      <b-badge
        v-for="tag in filteredTags"
        :key="tag.id"
        :variant="isSelected(tag.name) ? 'light-secondary' : 'light-primary'"
        class="all-tags-list__item cursor"
        pill
        @click="onTagClick(tag)"
      >
        {{ tag.name }}
        <span class="text-muted">({{ tag.newsCount }})</span>
      </b-badge>
    </div>
  </b-modal>
</template>

<script>
import {
  BBadge,
  BFormGroup,
  BFormInput,
  BModal,
} from 'bootstrap-vue'

export default {
  name: 'AllTagsModal',
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BBadge,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Array,
      default: () => [],
    },
    selectedTagNames: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchText: '',
    }
  },
  computed: {
    isModalVisible: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) this.$emit('close')
      },
    },
    sortedTags() {
      return [...this.tags].sort((a, b) => b.newsCount - a.newsCount || a.name.localeCompare(b.name, 'ru'))
    },
    filteredTags() {
      const query = this.searchText.trim().toLowerCase()
      if (!query) return this.sortedTags
      return this.sortedTags.filter(tag => tag.name.toLowerCase().includes(query))
    },
  },
  watch: {
    visible(value) {
      if (value) this.searchText = ''
    },
  },
  methods: {
    isSelected(name) {
      return this.selectedTagNames.some(
        selected => selected.toLowerCase() === name.toLowerCase(),
      )
    },
    onTagClick(tag) {
      if (this.isSelected(tag.name)) return
      this.$emit('select', tag)
    },
  },
}
</script>

<style lang="scss" scoped>
.all-tags-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.all-tags-list__item {
  font-size: 0.9rem;
  padding: 0.45rem 0.75rem;
  cursor: pointer;
  user-select: none;

  &:hover {
    opacity: 0.85;
  }
}

.cursor {
  cursor: pointer;
}
</style>
